// extracted by mini-css-extract-plugin
export default {"boxContent":"JP_ContactUs_boxContent__QhRoA"};